<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Billing statuses') }}</h1>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6 bg-white shadow overflow-hidden sm:rounded">
                <loading :status="loading"/>
                <template v-if="billingList.length > 0">
                    <ul>
                        <template v-for="(billing, index) in billingList">
                            <li :class="{'border-t border-gray-200': index !== 0}">
                                <router-link
                                    :to="'/workspace/admin/settings/billings/' + billing.id + '/edit'"
                                    class="flex items-center justify-between w-full px-4 py-4 sm:px-6 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
                                >
                                    <div class="min-w-0 flex-1 flex items-center">
                                        <div class="flex-shrink-0">
                                            <svg-vue :style="{color: billing.color || 'var(--ui-text-subtle)'}" class="h-4 w-4" icon="font-awesome.circle-solid"></svg-vue>
                                        </div>
                                        <div class="min-w-0 flex-1 px-4">
                                            <div class="text-sm font-medium leading-5 text-gray-900">
                                                {{ billing.value }}. {{ billing.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.angle-right-regular"></svg-vue>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </template>
                <template v-else-if="!loading">
                    <empty-state />
                </template>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "list",
    metaInfo() {
        return {
            title: this.$i18n.t('Billing statuses')
        }
    },
    data() {
        return {
            loading: true,
            billingList: [],
        }
    },
    mounted() {
        this.getBillings();
    },
    methods: {
        getBillings() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/billings').then(function (response) {
                self.billingList = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
